import "./ErrorPage.css";
import React from "react";
const siteUrl = process.env.REACT_APP_SITE_URL;

const ErrorPage = () => {
  return (
    <div className="error-body">
      מצטערים, <br />
      המשרה שחיפשת לא קיימת. <br />
      לצפייה במשרות נוספות: <a href={siteUrl}>Danel-Jobs</a>
    </div>
  );
};

export default ErrorPage;
